import Vue from 'vue'
import Vuex from 'vuex'

import auth from './modules/auth'
import download from './modules/download'
import loading from './modules/loading'
import notification from './modules/notification'
import ads from './modules/ads'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    download,
    loading,
    notification,
    ads
  }
})
